/**
 * Read a `File` (or `Blob`) and resolve to its `data:` URL representation.
 *
 * Used as the input format for Croppie, which can't bind directly to
 * an `ObjectURL` (it embeds the value in a CSS `background-image`, which
 * cancels itself on revoke) and won't accept a `File` object.
 */
export function fileToDataUrl(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error ?? new Error('FileReader failed'));
    reader.readAsDataURL(file);
  });
}
